import { render, staticRenderFns } from "./MesaObrasCopiaDePlanosConsultas.vue?vue&type=template&id=5a1179c6&"
import script from "./MesaObrasCopiaDePlanosConsultas.vue?vue&type=script&lang=js&"
export * from "./MesaObrasCopiaDePlanosConsultas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports